"use client";

import {
  REFERRAL_SOURCE_OPTIONS,
  type ReferralSource,
} from "@/lib/onboarding/constants";

import type { StepProps } from "../types";
import { ChoiceChip, ContinueButton, StepFooter, StepHeader } from "../ui";

const TITLE = "How did you find us?";

/** Optional attribution, shown to students and instructors. Chips record as
 *  they're tapped (tap the selected one again to clear it). The "Other" note
 *  is free text that may name a person, so it is asked on the About step,
 *  beside the consent, never here before sign-up. Skip clears the answer. */
export function ReferralStep({ state, update, advance }: StepProps) {
  const source = state.answers.referral_source;

  const toggle = (value: ReferralSource) => {
    update({ referral_source: source === value ? undefined : value });
  };

  return (
    <>
      <StepHeader
        kicker="One quick one"
        title={TITLE}
        body="Optional, but it helps a small team a lot."
      />
      <div
        role="group"
        aria-label={TITLE}
        className="mt-7 flex flex-wrap gap-2"
      >
        {REFERRAL_SOURCE_OPTIONS.map((value) => (
          <ChoiceChip
            key={value}
            label={value}
            selected={source === value}
            onSelect={() => toggle(value)}
          />
        ))}
      </div>
      <StepFooter>
        <ContinueButton onClick={() => advance()}>Continue</ContinueButton>
        <button
          type="button"
          onClick={() => advance({ referral_source: undefined })}
          className="h-11 w-full rounded-xl text-sm font-medium text-muted-foreground transition-colors outline-none hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50"
        >
          Skip
        </button>
      </StepFooter>
    </>
  );
}
